import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useStaffCardDetail = (id, enabled = true) => {
  return useQuery({
    queryKey: ["staffCardDetailState", id],
    enabled: enabled,
    queryFn: async () =>
      callApi({
        path: "staffcarddetail",
        command: "",
        data: JSON.stringify({
          data: { filter: { f_staffId: id } },
        }),
      }),
  });
};
